import { EType } from '../../../../../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';

export function getPhotoGalleryTitle(type: EType | null | undefined): string | null {
  switch (type) {
    case EType.BusinessCenter:
      return 'Фотографии бизнес-центра';
    case EType.ShoppingCenter:
      return 'Фотографии торгового-центра';
    case EType.Warehouse:
      return 'Фотографии складского комплекса';
    default:
      return null;
  }
}
